<template>
  <s-modal-card class="sm-modal">
    <template slot="title">
      Inner API Key
    </template>
    <div slot="body">
      <div class="text-bold">vt={{ api_key }}</div>
      <div class="text-xs">Available for testing</div>
      <!--TODO 将可以使用的URL列出来, 直接拷贝即可使用-->
    </div>
    <div slot="footer"></div>
  </s-modal-card>
</template>

<script>
export default {
  name: 'inner-api-key',
  data() {
    return {
      api_key: '',
    }
  },
  created() {
    this.getApiKey()
  },
  methods: {
    getApiKey() {
      this.$http
        .get('/api/users/api-token/')
        .then(res => {
          this.api_key = res.token
        })
        .catch(error => {
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    },
  },
}
</script>
